import { useEffect, useState } from "react";
import { api, fmtMoney, fmtDate } from "@/lib/api";
import { ArrowRight, PauseCircle } from "@phosphor-icons/react";

const COLUMNS = [
  { id: "hold", label: "Hold", desc: "Payable upon client receipt" },
  { id: "ready", label: "Ready to release", desc: "Cleared for approval" },
  { id: "approved", label: "Approved", desc: "Finance approved" },
  { id: "paid", label: "Paid", desc: "Settled with supplier" },
];

export default function Payables() {
  const [items, setItems] = useState([]);
  const load = async () => {
    const { data } = await api.get("/payables");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const action = async (id, op) => {
    await api.post(`/payables/${id}/${op}`, op === "hold" ? { reason: "Manually held" } : {});
    load();
  };

  const byStatus = (s) => items.filter(i => i.status === s);

  return (
    <div className="space-y-5" data-testid="payables-page">
      <div>
        <div className="label-eyebrow">Finance</div>
        <h1 className="font-display text-[28px] font-bold tracking-tight mt-1">Payables Dashboard</h1>
        <div className="text-[12px] text-[var(--span-text-2)] mt-1">
          5-stage workflow · Hold mechanism for "Payable Upon Client Receipt"
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-4" data-testid="payables-board">
        {COLUMNS.map(col => (
          <div key={col.id} className="kanban-col" data-testid={`payables-col-${col.id}`}>
            <div className="flex items-center justify-between mb-3">
              <div>
                <div className="label-eyebrow">{col.label}</div>
                <div className="text-[10px] text-[var(--span-text-2)] mt-0.5">{col.desc}</div>
              </div>
              <span className="font-mono text-[12px] font-bold tnum">{byStatus(col.id).length}</span>
            </div>
            {byStatus(col.id).map(it => (
              <div key={it.invoice_id} className="kanban-card" data-testid={`payable-${it.invoice_id}`}>
                <div className="text-[12px] font-medium truncate">{it.contractor_name}</div>
                <div className="font-mono text-[16px] font-bold mt-1 tnum">{fmtMoney(it.amount, it.currency)}</div>
                <div className="text-[10px] text-[var(--span-text-2)] mt-1 truncate">{it.description}</div>
                {it.hold_reason && (
                  <div className="badge badge-warn mt-2 text-[10px]"><PauseCircle size={10}/>&nbsp;{it.hold_reason}</div>
                )}
                <div className="text-[10px] text-[var(--span-text-2)] font-mono mt-2">{fmtDate(it.created_at)}</div>
                <div className="flex gap-1.5 mt-3">
                  {it.status === "hold" && <button onClick={() => action(it.invoice_id, "release")} data-testid={`release-${it.invoice_id}`} className="span-btn span-btn-ghost h-7 text-[11px]">Release <ArrowRight size={11}/></button>}
                  {it.status === "ready" && <button onClick={() => action(it.invoice_id, "approve")} data-testid={`approve-${it.invoice_id}`} className="span-btn h-7 text-[11px]">Approve <ArrowRight size={11}/></button>}
                  {it.status === "approved" && <button onClick={() => action(it.invoice_id, "pay")} data-testid={`pay-${it.invoice_id}`} className="span-btn h-7 text-[11px]">Pay <ArrowRight size={11}/></button>}
                  {it.status !== "hold" && it.status !== "paid" && <button onClick={() => action(it.invoice_id, "hold")} className="span-btn span-btn-ghost h-7 text-[11px]">Hold</button>}
                </div>
              </div>
            ))}
            {byStatus(col.id).length === 0 && <div className="text-[11px] text-[var(--span-text-2)] py-6 text-center">Empty</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
